<th scope="row" class="border-bold-left border-bold-right">
  {{ rowHeader | translate }}
</th>
<td class="text-align-right border-bold-right">
  {{ rowdata?.Min | replaceNullOrUndefinedTo:0 | numberFormat: crtLocale:minFractioningDigits }}
</td>
<td class="text-align-right border-bold-right">
  {{ rowdata?.Q1 | replaceNullOrUndefinedTo:0 | numberFormat: crtLocale:minFractioningDigits }}
</td>
<td class="text-align-right border-bold-right">
  {{ rowdata?.Q2 | replaceNullOrUndefinedTo:0 | numberFormat: crtLocale:minFractioningDigits }}
</td>
<td class="text-align-right border-bold-right">
  {{ rowdata?.Mean | replaceNullOrUndefinedTo:0 | numberFormat: crtLocale:minFractioningDigits }}
</td>
<td class="text-align-right border-bold-right">
  {{ rowdata?.Q3 | replaceNullOrUndefinedTo:0 | numberFormat: crtLocale:minFractioningDigits }}
</td>
<td class="text-align-right border-bold-right">
  {{ rowdata?.Max | replaceNullOrUndefinedTo:0 | numberFormat: crtLocale:minFractioningDigits }}
</td>
